import { Component, EventEmitter, Output, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  FormGroup,
  FormArray,
  Validators
} from '@angular/forms';


@Component({
  selector: 'app-file-upload',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,    
  ],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.css'
})
export class FileUploadComponent {
  @Input() label: string = 'Attach Document';
  @Output() filesSelectedEvent = new EventEmitter<File[]>();

  // TODO: will send whether the field is required or not
  form: FormGroup = new FormGroup({
    fileControl: new FormArray([], Validators.required),
  });

  // Handle file input change
  onFileUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const files = Array.from(input.files);
      this.filesSelectedEvent.emit(files);
    }
  }

}
